import React, { useState, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { autorun } from 'mobx';

const Loading = inject('userStore')(observer(({ userStore, children }) => {
	const [displayReady, setDisplayReady] = useState(false);

	useEffect(() => {
		const updateDisplay = () => {
			setDisplayReady(true)
		}

		userStore.fetchProfile()
		
		const disposer = autorun(() => {
			if (userStore.isLoading !== true) {
				updateDisplay()
				disposer()
			}
		})

		return () => {
			if (disposer) disposer()
		}
	}, [])

	if (!displayReady) {
		return (
			<div className="loading-container grid-x align-center align-middle">
				<div className="cell small-4">
					<div className="loading-spinner large">
						<div></div>
					</div>
				</div>
			</div>
		)
	}

	return children
}))

export default Loading
